import http from './http'
import store from '../store'

function login(){
    let params = {
        username: 'kx_huahua',
        password: 'kexin123',
        type: 1
    };
    http.post("/login", params).then((res) => {
        if (res.data.status_code == 200) {
            store.commit("setuserid", res.data.data.user_id);
            store.commit("settoken", res.data.data.access_token);
        }
    })
}

export default login